import { pagePanelCapacity } from './comicPageLayout'
import { isValidComicPanelAspect } from './comicPanelAspectUi'
import { getPanelsOnPage } from './comicPages'
import type { ComicEpisode, ComicPage } from './comicTypes'

/** 画布分页预览数据异常（不做静默兜底，须显式提示） */
export type ComicCanvasPagePreviewIssue =
  | 'missing_panel_aspect'
  | 'orphan_panel_refs'
  | 'panel_overflow'

export function resolveComicCanvasPagePreviewIssue(
  panelAspect: string,
  episode: ComicEpisode,
  page: ComicPage,
): ComicCanvasPagePreviewIssue | null {
  if (!isValidComicPanelAspect(panelAspect)) {
    return 'missing_panel_aspect'
  }
  const resolvedPanels = getPanelsOnPage(episode, page)
  if (page.panelIds.length > 0 && resolvedPanels.length < page.panelIds.length) {
    return 'orphan_panel_refs'
  }
  if (pagePanelCapacity(page).overflow > 0) {
    return 'panel_overflow'
  }
  return null
}

export function comicCanvasPagePreviewIssueDetail(issue: ComicCanvasPagePreviewIssue): string {
  switch (issue) {
    case 'missing_panel_aspect':
      return '画册单页比例（panelAspect）未设置或无效，无法预览分格。请补全画册设置，或重新应用包含该字段的工作流规划。'
    case 'orphan_panel_refs':
      return '本页分镜引用与话次数据不一致（部分分镜已删除或丢失）。请重新整理分镜或应用工作流规划修复。'
    case 'panel_overflow':
      return '本页分镜数量超出版式容量，请删除多余分镜或更换版式。'
  }
}

/** 本页尚无分镜格：版式有效，仅展示空槽骨架（非异常） */
export function isComicCanvasPageLayoutEmpty(page: ComicPage, episode: ComicEpisode): boolean {
  return getPanelsOnPage(episode, page).length === 0
}
